module.exports = __webpack_public_path__ + "img/16-white.305b6528.svg";